import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { appService } from '../../_services/app.service';
import { CommonService } from '../../_services/common.service';
import { ToastrService } from 'ngx-toastr';
import { CookieService } from 'ngx-cookie-service';
import { DatePipe } from '@angular/common';
import { RequestOptions, Http, Headers } from '@angular/http';
declare var $: any;
import { Helpers } from '../../../app/helpers';
import { environment } from '../../../environments/environment';
import { DecryptPipe } from '../../auth/_services/encrypt-decrypt.pipe';

declare var $: any;
@Component({
    selector: 'app-onfly-driver',
    templateUrl: './onfly-driver.component.html'
})
export class OnflyDriverComponent implements OnInit {
    static that: OnflyDriverComponent;
    hostUrl: any = environment.apiUrl;
    DriverStatusType: any = [];
    TenantId: any;
    TransportList: any = [];
    DriverDetail: any = {};
    DetailWithAddress: any = {};
    CurrentAddress: any = {};
    PermanentAddress: any = {};
    IsSameAsCurr: any = false;
    DriverType: any = [];
    selectFile: any;
    DriverPhotoName: any;
    AccountData: any = {};
    CompanyId: any;
    constructor(
        private _appService: appService,
        private commonService: CommonService,
        private toastr: ToastrService,
        public datepipe: DatePipe,
        private cookieservice: CookieService,
        private anghttp: Http,
        private decryptpipe: DecryptPipe
    ) {
        OnflyDriverComponent.that = this;
    }

    ngOnInit() {
        this.TenantId = JSON.parse(localStorage.getItem('ChnageCompnayId')).TenantId;
        this.GetDriverStatusType();
        this.GetDriverType();
        this.GetTransportList();
        this.RefreshDropdown();
        this.GetSelectData();
    }

    RefreshDropdown() {
        setTimeout(() => {
            (<any>$("#DriverStatusType")).selectpicker("refresh");
            (<any>$("#DriverTransporter")).selectpicker("refresh");
            (<any>$("#DriverType")).selectpicker("refresh");
        }, 1000);
    }

    ClearData() {
        this.DriverDetail = {};
        this.CurrentAddress = {};
        this.PermanentAddress = {};
        this.DetailWithAddress = {};
        $("#DriverAccountsType").val("");
        $('#DriverAccountsType').select2('destroy');
        this.GetSelectData();
        this.RefreshDropdown();
    }

    GetSelectData() {
        $("#DriverAccountsType").select2({
            width: "100%",
            escapeMarkup: function (markup) { return markup; },
            minimumInputLength: 2,
            ajax: {
                global: false,
                url: environment.apiUrl + "api/ChartsofAccount/GetAccountListforDriver",
                headers: {
                    "Authorization": OnflyDriverComponent.that._appService.getAuthToken(),
                },
                delay: 300,
                dataType: 'json',
                allowClear: true,
                data: function (params) {
                    return {
                        query: params.term,
                        page: params.page || 1,
                    };
                },
                processResults: function (data, params) {
                    params.page = params.page || 1;
                    return {
                        results: data.Results,
                        pagination: {
                            more: (params.page * 30) < data.Total
                        }
                    };
                },
            },
            tokenSeparators: [',', ' '],
            placeholder: 'Enter Account'
        });
    }

    GetDriverStatusType() {
        this._appService.GetById("Common", "GetLookByCategoryName", "DriverStatusType").subscribe(response => {
            this.DriverStatusType = response;
            (<any>$("#DriverStatusType")).selectpicker("refresh");
        }, err => {
            this.toastr.error("Error occurred while fetching Status data !", 'error');
        });
    }

    GetDriverType() {
        this._appService.GetById("Common", "GetLookByCategoryName", "DriverType").subscribe(response => {
            this.DriverType = response;
            (<any>$("#DriverType")).selectpicker("refresh");
        }, err => {
            this.toastr.error("Error occurred while fetching Status data !", 'error');
        });
    }

    GetTransportList() {
        this._appService.Get("VehicleMaster", "GetTranportList").subscribe(response => {

            this.TransportList = response;
            (<any>$("#DriverTransporter")).selectpicker("refresh");
        }, err => {
            this.toastr.error("Error occurred while fetching Trasporters data !", 'error');
        });
    }

    OnIsSameAsCurrent(IsSameAsCurr) {
        if (IsSameAsCurr == true) {
            this.PermanentAddress = this.CurrentAddress;
            $("#PermPermanentAdd").val($("#CurrBillAddress").val());
        }
        else {
            this.PermanentAddress = {};
            $("#PermPermanentAdd").val("");
        }
    }
    //--------When Transporter Selected Change Driver Type As per Transporter Type-----

    GetDriverTypeBasedOnTransporter(ID) {
        this.TransportList.forEach(element => {
            if (element.Id == ID) {
                this.DriverType.forEach(element1 => {
                    if (element.TransporterType == "Self") {
                        if (element1.Label == 'Employee') {
                            this.DriverDetail.DriverType = element1.Id;
                        }
                    }
                    if (element.TransporterType == "Attached") {
                        if (element1.Label == 'Attached') {
                            this.DriverDetail.DriverType = element1.Id;
                        }
                    }
                    if (element.TransporterType == "Hired") {
                        if (element1.Label == 'Third-Party') {
                            this.DriverDetail.DriverType = element1.Id;
                        }
                    }
                });
                setTimeout(() => {
                    (<any>$("#DriverType")).selectpicker("refresh");
                }, 100);
            }
        });
    }



    //----------------------------------Saving Data----------------------------------------

    SaveDetails() {
        return new Promise(async (resolve, reject) => {
            Helpers.setLoading(true);
            var flag = this.ValidateField();
            if (flag != false) {
                let Type = $("#DriverType option:selected").text().trim();
                if (Type == 'Employee') {
                    this.SaveData(true).then(resolve).catch(reject);
                }
                else {
                    this.SaveDriverDetails(false).then(resolve).catch(reject);
                }
                //resolve();
            }
            else {
                $("#SaveOnflyDriver").prop('disabled', false);
                reject("Please fill the Required Details");
            }
        });

    }

    SaveData(IsAuthorized) {
        return new Promise(async (resolve1, reject1) => {
            Helpers.setLoading(true);
            this.AccountData.Name = $("#DriverFirstName").val() + ' ' + $("#DriverLastName").val() + '-' + $("#DriverPhoneCode").val();
            this.AccountData.ParentId = $("#DriverAccountsType").val();
            this.AccountData.IsActive = true;
            this.AccountData.AccountType = 2;
            this.AccountData.CompanyId = JSON.parse(localStorage.getItem('ChnageCompnayId')).Id;
            this.AccountData.TenantId = JSON.parse(localStorage.getItem('ChnageCompnayId')).TenantId;
            this.AccountData.IsAuthorized = IsAuthorized;
            if (this.AccountData.ParentId != "") {
                this._appService.GetByThreeId("ChartsofAccount", "CheckAccountExist", this.AccountData.Id, this.AccountData.Name, this.AccountData.ParentId).subscribe(response => {
                    this._appService.Post("ChartsofAccount", "SaveAccount", this.AccountData).subscribe(async response => {
                        this.DriverDetail.AccountTypeId = $("#DriverAccountsType").val();;
                        this.DriverDetail.AccountId = response.Id;
                        this.AccountData.Id = this.DriverDetail.AccountId;
                        await this.SaveDriverDetails(IsAuthorized);
                        await this.AuthorizeDriver();
                        resolve1("");
                    }, err => {
                        reject1("Error occurred while saving data !");
                    });

                }, async err => {
                    this.DriverDetail.AccountTypeId = $("#DriverAccountsType").val();;
                    await this.SaveDriverDetails(IsAuthorized);
                    await this.AuthorizeDriver();
                    resolve1("");
                });
            }
            else {
                this.DriverDetail.AccountTypeId = $("#VehicleAccountsType").val();;
                await this.SaveDriverDetails(IsAuthorized);
                await this.AuthorizeDriver();
                resolve1("");
            }
            Helpers.setLoading(false);
        });
    }

    SaveDriverDetails(IsAuthorized) {
        return new Promise(async (resolve2, reject2) => {
            Helpers.setLoading(true);
            var flag = this.ValidateField();
            if (flag != false) {
                this.CurrentAddress.Address = $("#CurrBillAddress").val();
                this.PermanentAddress.Address = $("#PermPermanentAdd").val();
                this.DriverDetail.Remark = $("#DriverRemark").val();
                this.DriverDetail.TranspoterName = $("#DriverTransporter option:selected").text().trim();
                this.DriverDetail.IsAuthorized = IsAuthorized;
                this.DriverDetail.DriverCode = this.DriverDetail.MobileNo;
                this.DetailWithAddress.DriverDetail = this.DriverDetail;
                this.DetailWithAddress.CurrentAddress = this.CurrentAddress;
                this.DetailWithAddress.PermanentAddress = this.PermanentAddress;

                this._appService.Post("DriverMaster", "SaveDriverDetails", this.DetailWithAddress).subscribe(response => {
                    this.DriverDetail.Id = response;
                    this.toastr.success("Driver details saved Successfully !", 'Success');
                    resolve2("ok");
                }, err => {
                    reject2(err._body.replace(/"/g, ""));
                });
            }
            else {
                reject2("Please fill the Required Details !");
            }
            Helpers.setLoading(false);
        });
    }

    ValidateField() {
        var flag = true;
        if (!this.commonService.ValidateRequiredField($("#DriverFirstName"), 'Please Enter First Name', 'after', '')) {
            flag = false;
        }
        if (!this.commonService.ValidateRequiredField($("#DriverLastName"), 'Please Enter Last Name', 'after', '')) {
            flag = false;
        }
        if (!this.commonService.ValidateRequiredField($("#DriverPhoneCode"), 'Please Enter Mobile No', 'after', '')) {
            flag = false;
        }
        if (!this.commonService.ValidateRequiredField2($("#DriverStatusType"), $("#fieldsetDriverStatusType"), 'Please Select Status', 'after', '')) {
            flag = false;
        }
        if (!this.commonService.ValidateRequiredField2($("#DriverType"), $("#fieldsetDriverType"), 'Please Select Driver Type', 'after', '')) {
            flag = false;
        }
        if (!this.commonService.ValidateRequiredField2($("#DriverTransporter"), $("#FieldDriverTransporter"), 'Please Select Transporter', 'after', '')) {
            flag = false;
        }
        let Type = $("#DriverType option:selected").text().trim();
        if (Type == 'Employee') {
            if (!this.commonService.ValidateRequiredField2($("#DriverAccountsType"), $("#FieldSetDriverVehicleAccountsType"), 'Please Select Account', 'after', '')) {
                flag = false;
            }

        }


        if (!this.commonService.CheckEmail($("#DriverEmail1"), 'after')) {
            flag = false;
        }
        // if (!this.commonService.CheckPhoneNumber($("#DriverPhone12"), 'after')) {
        //   flag = false;
        // }

        return flag;
    }
    //--------------------------------Upload Phhoto-----------------------------------------

    OnDriverPhotoClick() {
        $("#DriverPhoto").trigger('click');
    }

    DriverPhotoClick(event) {
        this.selectFile = event.target.files[0];
        if (this.selectFile == undefined || this.selectFile == "" || this.selectFile == null) {
            this.toastr.error("Please select file to upload", "error");
            return false;
        }
        var fd = new FormData();
        if (fd.has('file')) {
            fd.set("file", this.selectFile);
        }
        else {
            fd.append("file", this.selectFile);
        }

        var headers = new Headers();
        let user_access_token = this.decryptpipe.transform(JSON.parse(this.cookieservice.get("user_access_token")));
        const token: string = 'Bearer ' + user_access_token;
        headers.append('Authorization', token);
        let options = new RequestOptions({ headers: headers })
        const apiUrl = environment.apiUrl + '/api/DriverMaster/UploadDriverPhoto';
        const req1 = this.anghttp.post(apiUrl, fd, options).subscribe(response => {

            let NewPic: string = JSON.parse(response['_body']);
            this.DriverPhotoName = NewPic;
            this.DriverDetail.FileName = NewPic.split(".")[0];
            this.DriverDetail.FileExtension = NewPic.split(".")[1];

            var path = environment.apiUrl + "../../Document/DriverPhotos/" + this.DriverPhotoName;
            $("#ShowDriverPhoto").attr("src", path);


            this.toastr.success("Successfully Updated !", 'success');
        },
            err => {
                this.toastr.error("Error occured while Uploading...", "error");
            }
        );
    }

    //-------------------------Authorize------------------------
    AuthorizeDriver() {
        return new Promise(async (resolve3, reject3) => {
            Helpers.setLoading(true);
            this.CompanyId = JSON.parse(localStorage.getItem('ChnageCompnayId')).Id;
            this._appService.GetByThreeId("Common", "AuthorizeTransaction", 8, this.DriverDetail.Id, this.CompanyId).subscribe(response => {
                resolve3(response);
                this.toastr.success("Driver Authorized Successfully !", 'Success');
            }, err => {
                reject3("An error occured !")
                this.toastr.error("An error occured !", 'error');
            });
            Helpers.setLoading(false);
        })
    }
}
